<template>
  <div id="container">
    <div class='box'>
      <div class="box_one" style="margin-bottom:5px"> 
        <cont-top/>
      </div> 

      <router-link :to="{ name: 'BrakepadsClassroom'  }">
        <div  style="margin-bottom:5px;background-color:#000"> 
          <cont-two/>
        </div>
      </router-link>

      <router-link :to="{ name: 'BrakediscClassroom'  }">
        <div  style="margin-bottom:5px;background-color:#000"> 
          <cont-three/>
        </div>
      </router-link>

      <router-link :to="{ name: 'BrakeoilClassroom'  }">
        <div  style="margin-bottom:5px;background-color:#000"> 
          <cont-four/>
        </div>
      </router-link>

      <router-link :to="{ name: 'OtherClassroom'  }">
        <div  style="margin-bottom:5px;background-color:#000"> 
          <cont-five/>
        </div>
      </router-link>

      <div class="box_bottom" > 
        <cont-bottom/>
      </div>
    </div>
  </div>
</template>

<script>
import ContTop from '@/views/brandClassroomPages/Cont_top' 
import ContTwo from '@/views/brandClassroomComponent/cont_two'
import ContThree from '@/views/brandClassroomComponent/cont_three'
import ContFour from '@/views/brandClassroomComponent/cont_four'
import ContFive from '@/views/brandClassroomComponent/cont_five'

import ContBottom from '@/views/Components/Cont_bottom'


export default {
  components: {
    ContTop ,
    ContBottom  ,

    ContTwo ,
    ContThree ,
    ContFour ,
    ContFive
  }
}
</script>

<style lang="stylus" scoped>
#container
  background-color : #000
  .box_one 
    width: 100%;
    background-repeat : no-repeat 
    background-size : cover
    background-color #000


  .box_bottom
    width: 100%;
    background-color #000


.box 
  width: 1003px;
  margin : 0 auto;
  background-color #fff
</style>